/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_CreatingInputs */

const en_users_creating = /** @type {(inputs: Users_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating…`)
};

const pt_br2_users_creating = /** @type {(inputs: Users_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando…`)
};

/**
* | output |
* | --- |
* | "Creating…" |
*
* @param {Users_CreatingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_creating = /** @type {((inputs?: Users_CreatingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_CreatingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_creating(inputs)
	return pt_br2_users_creating(inputs)
});